import { Avatar, Tooltip, Typography, Box } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class NovaDecisaoOuDespacho extends ReactComponent {
    constructor(props) {
        super(props);
        makeObservable(this, {
            registro: computed,
            indicadoresEncontrados: computed,
            total: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get indicadoresEncontrados() {
        return (this.registro?.processo?.indicadores || []).filter((i) => [303, 304].includes(i.codigo));
    }

    get total() {
        return this.indicadoresEncontrados.length;
    }

    render() {
        const { indicadoresEncontrados, total } = this;
        if (total === 0) return null;

        const corAmarela = 'rgb(253, 216, 53)';

        return (
            <Tooltip
                arrow
                title={
                    <Box sx={{ p: 0.5, pl: 2 }}>
                        {indicadoresEncontrados.map((i) => (
                            <Typography
                                key={i.codigo}
                                variant="caption"
                                sx={{ display: 'list-item', listStyleType: 'disc' }}
                            >
                                {i.descricao}
                            </Typography>
                        ))}
                    </Box>
                }
            >
                <Box
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        bgcolor: corAmarela,
                        borderRadius: '16px', // Mantém o visual arredondado
                        height: '24px',
                        pl: '3px', // Espaço antes do círculo preto
                        pr: '6px', // Espaço após a letra N para não vazar
                        cursor: 'default'
                    }}
                >
                    <Avatar
                        sx={{
                            bgcolor: '#000',
                            color: corAmarela,
                            width: 18,
                            height: 18,
                            fontSize: '0.7rem',
                            fontWeight: 'bold',
                            mr: '2px' // Espaçamento entre o círculo e o N
                        }}
                    >
                        {total}
                    </Avatar>
                    <Typography
                        variant="caption"
                        sx={{
                            color: '#000',
                            fontWeight: 'bold',
                            lineHeight: 1,
                            fontSize: '0.75rem'
                        }}
                    >
                        N
                    </Typography>
                </Box>
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(NovaDecisaoOuDespacho));
